import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";
import UpdateClientProductForm from "./UpdateClientProductForm";

const UpdateClientProductDialog = ({ product, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.detail.tabs.products.updateForm.title"
      description="clients.detail.tabs.products.updateForm.description"
      content={
        <UpdateClientProductForm product={product} onSubmitHandler={onSubmit} />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientProductDialog;
